import React from 'react';

// Locally hosted logo with white background removed (transparent PNG)
const LOGO_URL = '/behenchara-logo.png';

const BehencharaLogo = ({ className = 'h-10 w-auto', showText = false }) => {
  return (
    <div className="flex items-center gap-3">
      <img
        src={LOGO_URL}
        alt="Behenchara"
        className={className}
        style={{ objectFit: 'contain' }}
        data-testid="behenchara-logo-image"
      />
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-serif text-xl tracking-tight text-charcoal">BEHENCHARA</span>
          <span className="text-[10px] tracking-[0.2em] uppercase text-burgundy mt-1">Sisters Empowering Sisters</span>
        </div>
      )}
    </div>
  );
};

export default BehencharaLogo;
